var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, Input, ViewChild } from '@angular/core';
import { AuAction } from '../../action/au.action';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { CurrentUnitNode, CurrentUnitService } from './currentunit.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { UnitService } from '../../service/unit.service';
import { PartitionType, Unit } from '../../models/unit/unit';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { MenuService } from '../menu/menu.service';
import { ConditionService } from '../../service/condition.service';
var CurrentUnitComponent = /** @class */ (function (_super) {
    __extends(CurrentUnitComponent, _super);
    function CurrentUnitComponent(router, route, logger, action, service, uservice, message, page, mservice, condService) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.service = service;
        _this.uservice = uservice;
        _this.message = message;
        _this.page = page;
        _this.mservice = mservice;
        _this.condService = condService;
        _this.unit = true;
        _this.partition = false;
        _this.save_default = false;
        _this.componentName = CurrentUnitComponent.name;
        _this.all_events = [
            'init.jstree',
            'loading.jstree',
            'loaded.jstree',
            'ready.jstree',
            'load_node.jstree',
            'load_all.jstree',
            'model.jstree',
            'redraw.jstree',
            'before_open.jstree',
            'open_node.jstree',
            'after_open.jstree',
            'close_node.jstree',
            'after_close.jstree',
            'open_all.jstree',
            'close_all.jstree',
            'enable_node.jstree',
            'disable_node.jstree',
            'hide_node.jstree',
            'show_node.jstree',
            'hide_all.jstree',
            'show_all.jstree',
            'activate_node.jstree',
            'hover_node.jstree',
            'dehover_node.jstree',
            'select_node.jstree',
            'changed.jstree',
            'deselect_node.jstree',
            'select_all.jstree',
            'deselect_all.jstree',
            'set_state.jstree',
            'refresh.jstree',
            'refresh_node.jstree',
            'set_id.jstree',
            'set_text.jstree',
            'create_node.jstree',
            'rename_node.jstree',
            'delete_node.jstree',
            'move_node.jstree',
            'copy_node.jstree',
            'cut.jstree',
            'copy.jstree',
            'paste.jstree',
            'clear_buffer.jstree',
            'set_theme.jstree',
            'show_stripes.jstree',
            'hide_stripes.jstree',
            'show_dots.jstree',
            'hide_dots.jstree',
            'show_icons.jstree',
            'hide_icons.jstree',
            'show_ellipsis.jstree',
            'hide_ellipsis.jstree',
            'disable_checkbox.jstree',
            'enable_checkbox.jstree',
            'check_node.jstree',
            'uncheck_node.jstree',
            'check_all.jstree',
            'uncheck_all.jstree',
            'show_contextmenu.jstree',
            'search.jstree',
            'clear_search.jstree',
            'state_ready.jstree'
        ];
        _this.plugins = [
            'wholerow',
            'checkbox',
            'search',
            'types'
        ];
        _this.limit = 10;
        _this.search = false;
        _this.tree_data = new Subject();
        _this.ignore_events = ['hover_node.jstree', 'dehover_node.jstree'];
        _this.is_control_tree_monitor = false;
        _this.unitSubscription = _this.uservice.get().subscribe(function (unit) {
            if (Unit.isUnit(unit)) {
                _this.currentUnit = unit;
                _this.partition = false;
                if (_this.currentUnit.partition_type === PartitionType.includeLower) {
                    _this.partition = true;
                }
            }
        });
        return _this;
    }
    CurrentUnitComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.element = this.treeElement.nativeElement;
        this.modal = this.remodalElement.nativeElement;
        this.init();
    };
    CurrentUnitComponent.prototype.tree = function () {
        return $(this.element).jstree(true);
    };
    ;
    // public unit: Unit;
    // @Input() unit: Unit;
    CurrentUnitComponent.prototype.init = function () {
        var _this = this;
        var self = this;
        this.tree_data.subscribe(function (data) {
            var coreData = function ($node, cb) {
                if ($node.id === '#') {
                    cb(data);
                }
                else {
                    var load_data = self.onLoadNode($node);
                    cb(load_data);
                }
            };
            var tree = self.tree();
            if (!tree) {
                $(self.element).jstree({
                    core: {
                        check_callback: true,
                        data: coreData,
                        themes: {
                            icons: false
                        }
                    },
                    checkbox: {
                        keep_selected_style: false,
                        whole_node: false,
                        tie_selection: false,
                        visible: false
                    },
                    search: {
                        show_only_matches: true
                    },
                    types: {
                        more: {
                            valid_children: []
                        }
                    },
                    plugins: _this.plugins
                });
                var events = self.all_events.filter(function (element) {
                    return self.ignore_events.indexOf(element) == -1;
                });
                $(self.element).on(events.join(' '), function (e, data) {
                    self.onEvent(e, e.type, data);
                });
            }
            else {
                tree.settings.core.data = coreData;
                $(self.element).jstree('refresh');
            }
        });
    };
    CurrentUnitComponent.prototype.setUnsubscribe = function () {
        this.refSubscription.unsubscribe();
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    CurrentUnitComponent.prototype.applyToTreeData = function (recs) {
        this.is_control_tree_monitor = true;
        this.tree_data.next(this.createTreeData(recs));
        this.is_control_tree_monitor = false;
    };
    CurrentUnitComponent.prototype.createTreeData = function (recs) {
        var data = [];
        for (var _i = 0, recs_1 = recs; _i < recs_1.length; _i++) {
            var rec = recs_1[_i];
            data.push(new UnitNode(rec, this.search));
            if (data.length == this.limit && this.limit < recs.length && !this.search) {
                data.push(this.createMoreNode());
                break;
            }
        }
        return data;
    };
    CurrentUnitComponent.prototype.onEvent = function (e1, e2, rec) {
        // this.logger.debug(e2);
        if (e2 === 'select_node') {
            if (rec.node.type === 'more' && rec.event.type === 'click') {
                this.onMoreNode(rec);
            }
            else {
                this.onSelectNode(rec);
            }
        }
        else if (e2 === 'load_node') {
            if (this.search) {
                this.search = false;
                this.tree().search(this.treeSearch);
            }
        }
    };
    CurrentUnitComponent.prototype.onEventSubscribe = function (event) {
        if (event === 'ErrMSG000004' || event === 'ErrMSG000006') {
            this.open(true);
        }
        else if (event === 'ErrMSG000005') {
            this.router.navigate(['/login']);
        }
    };
    CurrentUnitComponent.prototype.onSelectNode = function (rec) {
        var _this = this;
        var self = this;
        if (rec.node.state.disabled) {
            return;
        }
        var data = { unit_m_id: rec.node.id };
        if (this.save_default) {
            data['default'] = true;
        }
        this.service.updateRecord(data).subscribe(function (result) {
            self.condService.setResetFlg(true);
            self.router.navigate(['/top']);
            self.mservice.setMenuOpenState('menu-current', null);
            // self.remodal.$wrapper.one('closed', function () {
            //     self.remodal.destroy();
            //     self.remodal = null;
            // });
            self.remodal.close();
        }, function (err) {
            _this.logger.error(err);
        });
    };
    CurrentUnitComponent.prototype.onLoadNode = function (rec) {
        var recs = jsonpath.value(this.org_data, '$..[?(@.id==' + rec.id + ')]');
        recs = recs.children;
        return this.createTreeData(recs);
    };
    CurrentUnitComponent.prototype.onMoreNode = function (rec) {
        var node = rec.node;
        var parent_node = this.tree().get_node(node.parent);
        var scrollTop = $(this.modal).parent().scrollTop();
        var page = node.data.page;
        var offset = page * this.limit;
        var recs = (node.parent === '#' ? this.org_data : jsonpath.value(this.org_data, '$..[?(@.id==' + node.parent + ')]').children);
        var count = 0;
        this.tree().delete_node(node);
        for (var i = offset; i < recs.length; i++) {
            this.tree().create_node(parent_node, new UnitNode(recs[i], this.search));
            count++;
            if (count == this.limit && offset + this.limit < recs.length && !this.search) {
                this.tree().create_node(parent_node, this.createMoreNode(page + 1));
                break;
            }
        }
        $(this.modal).parent().scrollTop(scrollTop);
    };
    CurrentUnitComponent.prototype.createMoreNode = function (page) {
        if (page === void 0) { page = 1; }
        return new UnitNode({ more: true, page: page }, this.search, this.msgSnapshot);
    };
    CurrentUnitComponent.prototype.onSearch = function () {
        if (!this.treeSearch) {
            return;
        }
        this.search = true;
        this.applyToTreeData(this.org_data);
    };
    CurrentUnitComponent.prototype.onSearchClear = function () {
        this.search = false;
        this.treeSearch = '';
        if (this.tree()) {
            this.tree().clear_search();
        }
        this.applyToTreeData(this.org_data);
    };
    CurrentUnitComponent.prototype.open = function (def) {
        this.remodal = $(this.modal).remodal({ hashTracking: false, closeOnEscape: false, closeOnOutsideClick: false });
        this.save_default = def;
        this.tree_data.next([]);
        this.treeSearch = '';
        var self = this;
        this.remodal.$modal.one('opened', function () {
            self.service.getRecord().subscribe(function (rec) {
                if (rec instanceof Array) {
                    self.org_data = rec;
                    self.onSearchClear();
                }
            });
        });
        this.remodal.open();
    };
    CurrentUnitComponent.prototype.children = function (node, data) {
        for (var _i = 0, _a = node.children; _i < _a.length; _i++) {
            var n = _a[_i];
            if (typeof data[n].li_attr.class !== 'undefined') {
                data[n].li_attr.class = parseInt(data[n].li_attr.class) + 1;
            }
            this.children(data[n], data);
        }
    };
    CurrentUnitComponent.prototype.changePartition = function () {
        var _this = this;
        var partition_type = PartitionType.current;
        if (this.partition) {
            partition_type = PartitionType.includeLower;
        }
        this.service.updateRecord({
            unit_m_id: this.currentUnit.id,
            partition_type: partition_type
        }).subscribe(function (result) {
            _this.router.navigate(['/top']);
            _this.mservice.setMenuOpenState('menu-current', null);
        }, function (err) {
            _this.logger.error(err);
        });
    };
    CurrentUnitComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.tree_data.unsubscribe();
        this.unitSubscription.unsubscribe();
        if ($(this.modal).parent().hasClass('remodal-wrapper')) {
            this.remodal.destroy();
        }
    };
    CurrentUnitComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'currentunit',
                    template: "<ng-template [ngIf]=\"unit\">\n  <a *ngIf=\"!!currentUnit\" href=\"javascript:void(0);\" (click)=\"open(false)\">{{ currentUnit.label }}</a>\n  <input class=\"hNav_partitionInput\" type=\"checkbox\" id=\"partition\" name=\"partition\" [(ngModel)]=\"partition\" (change)=\"changePartition()\">\n  <label *ngIf=\"currentUnit?.id\" class=\"hNav_partitionLabel\" for=\"partition\">\n    <span class=\"hNav_partitionTooltip hNav_partitionTooltip-default\">{{ (msg | async)['CurrentUnitComponent.current'] }}</span>\n    <span class=\"hNav_partitionTooltip hNav_partitionTooltip-checked\">{{ (msg | async)['CurrentUnitComponent.includeLower'] }}</span>\n  </label>\n</ng-template>\n<!-- remodal -->\n<div class=\"remodal\" id=\"{{ componentName + '#Remodal#CurrentUnit' }}\" #remodal>\n  <div class=\"remodal_whitebg\">\n    <p class=\"textArea_heading\">{{ (msg | async)['Please.select.tenant'] }}</p>\n    <ul [key]=\"'btn'\" buttonDir>\n      <li [key]=\"'btn'\" buttonDir>\n        <input type=\"text\" class=\"checkTree_searchInput\" placeholder=\"{{ (msg | async)['Search...'] }}\" name=\"treeSearch\" [(ngModel)]=\"treeSearch\">\n      </li>\n      <li [key]=\"'btn'\" buttonDir>\n        <item-btn [key]=\"'btn'\" [btn]=\"{\n                                    type: 'button',\n                                    event: componentName + '#Button#search',\n                                    caption: (msg | async)['SearchConditionComponent.button.search'],\n                                    params: {btnClass: {sm: true}}\n                                }\" (clickBtn)=\"onSearch()\"></item-btn>\n      </li>\n      <li [key]=\"'btn'\" buttonDir>\n        <item-btn [key]=\"'btn'\" [btn]=\"{\n                                    type: 'button',\n                                    event: componentName + '#Button#searchClear',\n                                    caption: (msg | async)['SearchConditionComponent.button.clear'],\n                                    params: {btnClass: {sm: true, type: 'delete'}}\n                                }\" (clickBtn)=\"onSearchClear()\"></item-btn>\n      </li>\n    </ul>\n    <div class=\"tenantTree\">\n      <div id=\"tenantTree\" #tree>\n      </div>\n    </div>\n  </div>\n  <div *ngIf=\"!save_default\" class=\"remodal_btns\">\n    <ul class=\"remodal_btns_group\">\n      <li>\n        <button data-remodal-action=\"cancel\" type=\"reset\" class=\"remodal_btns_group-cancel\">Cancel</button>\n      </li>\n    </ul>\n  </div>\n</div>\n<!-- /remodal -->\n",
                    styles: [".remodal /deep/ a.tenantTree_disabled,\n.remodal /deep/ .tenantTree_disabled {\n  color: rgba(0, 0, 0, 0.3) !important;\n}\n\n.remodal /deep/ .tenantTree_disabled {\n  position: relative;\n  cursor: default;\n}\n\n.remodal /deep/ .tenantTree_disabled .jstree-checkbox {\n  opacity: .5 !important;\n}\n\n.remodal /deep/ .tenantTree_disabled .jstree-checkbox::before,\n.remodal /deep/ .tenantTree_disabled .jstree-checkbox::after {\n  content: '';\n  background: gray;\n  width: 18px;\n  height: 1px;\n  top: 12px;\n  left: 3px;\n  transform: rotate(45deg);\n  position: absolute;\n}\n\n.remodal /deep/ .tenantTree_disabled .jstree-checkbox::after {\n  transform: rotate(-45deg);\n}\n"]
                }] }
    ];
    /** @nocollapse */
    CurrentUnitComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: CurrentUnitService },
        { type: UnitService },
        { type: MessageService },
        { type: PageService },
        { type: MenuService },
        { type: ConditionService }
    ]; };
    CurrentUnitComponent.propDecorators = {
        unit: [{ type: Input }],
        treeElement: [{ type: ViewChild, args: ['tree',] }],
        remodalElement: [{ type: ViewChild, args: ['remodal',] }]
    };
    return CurrentUnitComponent;
}(ContentBaseComponent));
export { CurrentUnitComponent };
var UnitNode = /** @class */ (function (_super) {
    __extends(UnitNode, _super);
    function UnitNode(rec, search, msg) {
        if (msg === void 0) { msg = {}; }
        var _this = _super.call(this, rec) || this;
        if (rec['id'] != null) {
            _this.id = rec.id;
            rec.node_id = _this.id;
        }
        _this.state.disabled = rec.disable;
        if (!rec.grant) {
            _this.state.disabled = true;
        }
        if (_this.state.disabled) {
            _this.a_attr.class = 'tenantTree_disabled';
        }
        if (rec != null) {
            if (rec['children'] != null) {
                if (search) {
                    _this.children = [];
                    for (var _i = 0, _a = rec['children']; _i < _a.length; _i++) {
                        var child = _a[_i];
                        _this.children.push(new UnitNode(child, search));
                    }
                }
                else if (rec['children'].length > 0) {
                    _this.children = true;
                }
            }
        }
        if (rec['more']) {
            _this.text = '<a href="javascript:void(0);">' + msg['au.COMPONENTS.label.tree.more'] + '</a>';
            _this.type = 'more';
            _this.li_attr.class = 'checkTree_more';
            _this.state.disabled = false;
        }
        return _this;
    }
    return UnitNode;
}(CurrentUnitNode));
//# sourceMappingURL=currentunit.component.js.map